module.exports = __webpack_public_path__ + "c22d981272b78c1776373c710fb0f478.pdf";